import { render } from "./CertificateDownload.vue?vue&type=template&id=20d615ba&ts=true"
import script from "./CertificateDownload.vue?vue&type=script&lang=ts"
export * from "./CertificateDownload.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__